import { createSlice } from '@reduxjs/toolkit';

import initialState from './state';
import { authenticateUser, logoutUser } from './actions';

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {},
  extraReducers: builder =>
    builder
      .addCase(authenticateUser.fulfilled, (state, action) => {
        state = action.payload as any;
        return state;
      })
      .addCase(logoutUser.fulfilled, state => {
        state = initialState;
        return state;
      }),
});

export default userSlice;
